import { Divider } from '@mui/material';
import { ApiLevel } from '@testing-library/user-event/dist/cjs/utils/index.js';
import React from 'react'
import { useTranslation } from 'react-i18next';

export const ReferrerDetails = ({ applicantData }) => {
  const { t } = useTranslation();
  return (
    <div className="applicantDetailsCard">
      <h3 className="titlePersonalHD marginBottom10">{applicantData?.primarySource || "N/A"}</h3>
      <Divider sx={{ border: '1px dashed #D6D6D6', mb: 2, mt: 2 }} />
      <h3 className="titlePersonalHD marginBottom10">Referrer Details</h3>
      <div className="personalInfo width50">

        {applicantData?.sourceDetails?.name ? (
          <div className="personalInfoRow">
            <label className="label200">{t("voucherPreview.thankYou.customerName")}</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.name || "N/A"}
            </span>
          </div>
        ) : null}

        {applicantData?.sourceDetails?.projectName ? (
          <div className="personalInfoRow">
            <label className="label200">{t("voucherPreview.referrerDetails.project")}:</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.projectName || "N/A"}
            </span>
          </div>
        ) : null}

        {applicantData?.sourceDetails?.contactNumber ? (
          <div className="personalInfoRow">
            <label className="label200">{t("commonLabels.contactNumber")}:</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData && applicantData?.sourceDetails?.contactNumber
                ? `${applicantData?.sourceDetails?.countryCode} ${applicantData?.sourceDetails?.contactNumber}`
                : "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.unit ? (
          <div className="personalInfoRow">
            <label className="label200">{t("voucherPreview.referrerDetails.unit")}:</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.unit || "N/A"}
            </span>
          </div>
        ) : null}

        {applicantData?.sourceDetails?.email ? (
          <div className="personalInfoRow">
            <label className="label200">{t("commonLabels.email")}:</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.email || "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.referredBy ? (
          <div className="personalInfoRow">
            <label className="label200">{t("voucherPreview.referrerDetails.referredBy")}:</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.referredBy || "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.employeeName ? (
          <div className="personalInfoRow">
            <label className="label180">{t("voucherPreview.referrerDetails.empName")}:</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.employeeName || "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.employeeId ? (
          <div className="personalInfoRow">
            <label className="label200">{t("voucherPreview.referrerDetails.empId")}:</label>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.employeeId || "N/A"}
            </span>
          </div>
        ) : null}


      </div>

    </div>
  )
}
